import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const PropertyModal = ({ property, onClose }) => {
  if (!property) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '1rem',
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          padding: '0',
          borderRadius: '20px',
          maxWidth: '900px',
          width: '100%',
          maxHeight: '90vh',
          position: 'relative',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          style={{
            position: 'absolute',
            top: '1.5rem',
            right: '1.5rem',
            background: 'rgba(255, 255, 255, 0.9)',
            border: 'none',
            fontSize: '1.2rem',
            cursor: 'pointer',
            color: '#374151',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1001,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            transition: 'all 0.2s ease',
          }}
          onClick={onClose}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 1)';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.9)';
            e.target.style.transform = 'scale(1)';
          }}
        >
          &times;
        </button>

        {/* Carousel for multiple images */}
        {property.images && property.images.length > 0 && (
        <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={true}
        infiniteLoop
        autoPlay={false}
        emulateTouch
        swipeable
        useKeyboardArrows
        dynamicHeight={true}
        className="modern-carousel"
      >
        {property.images?.map((img, index) => (
          <div key={index}>
            <img 
              src={img.asset.url} 
              alt={`Property image ${index + 1}`} 
              style={{ 
                width: '100%', 
                height: '400px',
                objectFit: 'cover',
                display: 'block'
              }}
            />
          </div>
        ))}
      </Carousel>
      
        )}

        {/* Property Details */}
        <div style={{ padding: '2rem' }}>
          <div style={{ marginBottom: '1.5rem' }}>
            <h2 style={{ 
              fontSize: '1.75rem', 
              fontWeight: '700', 
              color: '#1f2937', 
              marginBottom: '0.5rem',
              lineHeight: '1.3'
            }}>
              {property.location}
            </h2>
            
            {property.price && (
              <p style={{ 
                fontSize: '1.5rem', 
                fontWeight: '600', 
                color: '#059669',
                margin: '0 0 1rem 0'
              }}>
                £{property.price.toLocaleString()}
              </p>
            )}
          </div>
          
          <div style={{ 
            display: 'flex', 
            gap: '2rem', 
            flexWrap: 'wrap', 
            marginBottom: '1.5rem',
            padding: '1rem',
            backgroundColor: '#f8fafc',
            borderRadius: '12px',
            border: '1px solid #e2e8f0'
          }}>
            {property.bedrooms && (
              <div style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 1rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
              }}>
                <img 
                  src="/icons/bed.png" 
                  alt="bedrooms" 
                  style={{ width: '18px', height: '18px' }}
                />
                <span style={{ 
                  fontSize: '1rem', 
                  color: '#374151',
                  fontWeight: '500'
                }}>
                  {property.bedrooms} bed{property.bedrooms !== 1 ? 's' : ''}
                </span>
              </div>
            )}
            
            {property.bathrooms && (
              <div style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 1rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
              }}>
                <img 
                  src="/icons/bathroom.png" 
                  alt="bathrooms" 
                  style={{ width: '18px', height: '18px' }}
                />
                <span style={{ 
                  fontSize: '1rem', 
                  color: '#374151',
                  fontWeight: '500'
                }}>
                  {property.bathrooms} bath{property.bathrooms !== 1 ? 's' : ''}
                </span>
              </div>
            )}
          </div>
          
          {property.propertyType && (
            <div style={{ 
              display: 'inline-block',
              padding: '0.5rem 1rem',
              backgroundColor: '#3b82f6',
              color: 'white',
              fontSize: '0.875rem', 
              textTransform: 'uppercase', 
              letterSpacing: '0.5px',
              fontWeight: '600',
              borderRadius: '20px'
            }}>
              {property.propertyType}
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .modern-carousel .carousel .control-arrow {
          background: rgba(255, 255, 255, 0.9) !important;
          border-radius: 50% !important;
          width: 50px !important;
          height: 50px !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
          transition: all 0.2s ease !important;
        }
        
        .modern-carousel .carousel .control-arrow:hover {
          background: rgba(255, 255, 255, 1) !important;
          transform: translateY(-50%) scale(1.1) !important;
        }
        
        .modern-carousel .carousel .control-prev {
          left: 20px !important;
        }
        
        .modern-carousel .carousel .control-next {
          right: 20px !important;
        }
        
        .modern-carousel .carousel .control-arrow:before {
          border-top: 8px solid transparent !important;
          border-bottom: 8px solid transparent !important;
          border-right: 8px solid #374151 !important;
          border-left: 8px solid #374151 !important;
        }
        
        .modern-carousel .carousel .control-prev:before {
          border-right: 8px solid #374151 !important;
          border-left: none !important;
        }
        
        .modern-carousel .carousel .control-next:before {
          border-left: 8px solid #374151 !important;
          border-right: none !important;
        }
        
        .modern-carousel .carousel .control-arrow:focus {
          outline: none !important;
        }
        
        .modern-carousel .carousel .control-arrow:focus-visible {
          outline: none !important;
        }
        
        .modern-carousel .carousel .slider-wrapper {
          border-radius: 20px 20px 0 0 !important;
          overflow: hidden !important;
        }
        
        .modern-carousel .carousel .slider {
          border-radius: 20px 20px 0 0 !important;
        }
        
        .modern-carousel .carousel .carousel-status {
          display: none !important;
        }
        
        .modern-carousel .carousel .thumbs-wrapper {
          display: none !important;
        }
        
        @media (max-width: 768px) {
          .modern-carousel .carousel .control-arrow {
            width: 40px !important;
            height: 40px !important;
          }
          
          .modern-carousel .carousel .control-prev {
            left: 10px !important;
          }
          
          .modern-carousel .carousel .control-next {
            right: 10px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PropertyModal;
